import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Table, Form, InputGroup, Spinner, Badge, Modal } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';

const getApiUrl = () => localStorage.getItem('apiUrl') || 'http://localhost:8000';
const fmt = (n) => (n || 0).toLocaleString('id-ID');

const KasKasir = () => {
  const kirsRef = useRef(null);
  const jenisPembayaranRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [menus, setMenus] = useState([]);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [time, setTime] = useState({ date: '', clock: '' });

  const [listKas, setListKas] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showModalPaket, setShowModalPaket] = useState(false);
  const [listRekening, setListRekening] = useState([]);
  const [jenisPembayaranCode, setJenisPembayaranCode] = useState('');
  const [jenisKartu, setJenisKartu] = useState('');
  const [inputNilai, setInputNilai] = useState('');
  const [inputAdmBank, setInputAdmBank] = useState('');
  const inputSubTotal = (parseFloat(inputNilai) || 0) + (parseFloat(inputAdmBank) || 0);
  
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const today = new Date();
  const fmtDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  const [periodeAwal, setPeriodeAwal] = useState(fmtDate(new Date(today.getFullYear(), today.getMonth(), 1)));
  const [periodeAkhir, setPeriodeAkhir] = useState(fmtDate(today));

  useEffect(() => {
    const savedMenu = localStorage.getItem('mainmenu');
    if (savedMenu) {
      try { setMenus(JSON.parse(savedMenu)); } catch (e) { setMenus([]); }
    }
    const updateTime = () => {
      const now = new Date();
      const dd = String(now.getDate()).padStart(2, '0');
      const mm = String(now.getMonth() + 1).padStart(2, '0');
      const hh = String(now.getHours()).padStart(2, '0');
      const mi = String(now.getMinutes()).padStart(2, '0');
      const ss = String(now.getSeconds()).padStart(2, '0');
      setTime({ date: `${dd}/${mm}/${now.getFullYear()}`, clock: `${hh}:${mi}:${ss}` });
    };
    updateTime();
    const timer = setInterval(updateTime, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchKasKasir = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      let username = '';
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        username = payload.user || payload.username || payload.sub || '';
      } catch (e) { username = ''; }
      const res = await fetch(`${getApiUrl()}/kas_kasir?token=${encodeURIComponent(token)}&username=${encodeURIComponent(username)}&periode=${periodeAwal}&periode2=${periodeAkhir}`);
      const json = await res.json();
      setListKas(Array.isArray(json.kas_kasir) ? json.kas_kasir : []);
    } catch (err) { 
      setListKas([]); 
    } finally { 
      setIsLoading(false); 
    }
  };

  useEffect(() => { fetchKasKasir(); }, []); // eslint-disable-line

  const filteredList = listKas.filter(item =>
    (item.keterangan || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
    (item.no_nota || '').toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalMasuk = filteredList.reduce((a, c) => a + (c.tunai || 0) + (c.bank || 0) + (c.dokumen || 0) + (c.piutang || 0), 0);
  const totalKeluar = filteredList.reduce((a, c) => a + (c.keluar || 0), 0);
  const saldo = totalMasuk - totalKeluar;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  useEffect(() => { setCurrentPage(1); }, [searchQuery, listKas]);


  const fetchRekening = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${getApiUrl()}/show_rekening?token=${encodeURIComponent(token)}`);
      const json = await res.json();
      if (json && json.list_rekening) {
        setListRekening(json.list_rekening);
      } else if (Array.isArray(json)) {
        setListRekening(json);
      }
    } catch (err) {
      console.error("Gagal load show_rekening", err);
    }
  };

  useEffect(() => {
    if (showModalPaket) {
      fetchRekening();
    }
  }, [showModalPaket]);
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: "'Inter', 'Segoe UI', sans-serif", display: 'flex', flexDirection: 'column' }}>
      
      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg shadow-sm" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', borderBottom: 'none', padding: '0 1.5rem', height: '48px' }}>
        <div className="container-fluid px-0">
          <a className="navbar-brand d-flex align-items-center gap-2" href="/" style={{ fontSize: '0.85rem', fontWeight: 700, color: '#fff' }}>
            <div style={{ background: 'rgba(255,255,255,0.1)', padding: '4px 8px', borderRadius: '6px' }}>
              <i className="bi bi-wallet2 text-warning fs-6"></i>
            </div>
            SIMRS2
          </a>
          <button className="navbar-toggler border-0" type="button" onClick={() => setIsNavOpen(!isNavOpen)}>
            <i className="bi bi-list text-white fs-5"></i>
          </button>
          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`}>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 flex-row gap-3 ms-4">
              {menus.map((item) => {
                const isActive = location.pathname.toLowerCase() === (item.lnk || '').toLowerCase();
                return (
                  <li className="nav-item" key={item.id_mn}>
                    <a href={item.lnk || '#'} className="nav-link py-1 px-2 rounded" style={{ color: isActive ? '#fff' : 'rgba(255,255,255,0.65)', fontSize: '0.75rem', fontWeight: isActive ? 600 : 500, background: isActive ? 'rgba(13,148,136,0.4)' : 'transparent' }}>
                      {item.nm_mn}
                    </a>
                  </li>
                );
              })}
            </ul>
            <div className="d-flex align-items-center gap-3">
              <span className="text-white-50 fw-medium d-none d-lg-flex align-items-center gap-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-clock"></i> {time.clock}
              </span>
              <Button 
                variant="outline-danger" 
                size="sm" 
                className="d-flex align-items-center gap-1 py-1" 
                style={{ fontSize: '0.75rem', borderRadius: '6px', fontWeight: 600 }} 
                onClick={() => {
                  if (location.state && location.state.from === '/PoliKlinik') {
                    navigate('/PoliKlinik');
                  } else {
                    localStorage.clear();
                    navigate('/');
                  }
                }}
              >
                <i className={location.state && location.state.from === '/PoliKlinik' ? "bi bi-arrow-left" : "bi bi-box-arrow-right"}></i>
                {location.state && location.state.from === '/PoliKlinik' ? "Tutup" : "Keluar"}
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* PAGE HEADER */}
      <div style={{ background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)", padding: "0.85rem 1.5rem", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between flex-wrap gap-2">
          <div className="d-flex align-items-center gap-3">
            <Button
              size="sm"
              onClick={() => navigate(-1)}
              style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "#fff", borderRadius: "7px", padding: "5px 12px", fontSize: "0.78rem", fontWeight: 600 }}
            >
              <i className="bi bi-arrow-left me-1"></i>Kembali
            </Button>
            <div style={{ background: "rgba(255,255,255,0.2)", borderRadius: "8px", padding: "8px 10px" }}>
              <i className="bi bi-journal-text text-white fs-5"></i>
            </div>
            <div>
              <div className="text-white fw-bold" style={{ fontSize: "1rem", letterSpacing: "0.3px" }}>BUKU KAS KASIR</div>
              <div className="text-white-50" style={{ fontSize: "0.72rem" }}>Laporan Pemasukan & Pengeluaran Kas</div>
            </div>
          </div>
          <div className="text-white-50" style={{ fontSize: "0.75rem" }}>
            <i className="bi bi-calendar3 me-1"></i>{time.date}
          </div>
        </div>
      </div>

      <Container fluid className="p-3 flex-grow-1" style={{ maxWidth: '1600px' }}>

        
        {/* TOMBOL AKSI */}
        <div className="d-flex flex-wrap gap-3 mb-4">
          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-4 py-2 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-danger-subtle text-danger" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-x-octagon-fill"></i>
            </div>
            <span className="fw-bold" style={{ color: '#334155', fontSize: '0.8rem', letterSpacing: '0.3px' }}><u style={{ textDecorationThickness: '2px', textUnderlineOffset: '3px' }}>B</u>ATAL KUITANSI</span>
          </Button>
          
          <Button variant="white" className="d-flex align-items-center gap-2 border shadow-sm px-4 py-2 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-success-subtle text-success" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-arrow-left-right fw-bold"></i>
            </div>
            <span className="fw-bold" style={{ color: '#334155', fontSize: '0.8rem', letterSpacing: '0.3px' }}><u style={{ textDecorationThickness: '2px', textUnderlineOffset: '3px' }}>M</u>UTASI KAS</span>
          </Button>

          <Button variant="white" onClick={() => setShowModalPaket(true)} className="d-flex align-items-center gap-2 border shadow-sm px-4 py-2 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-warning-subtle text-warning-emphasis" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-box-seam-fill"></i>
            </div>
            <span className="fw-bold" style={{ color: '#334155', fontSize: '0.8rem', letterSpacing: '0.3px' }}><u style={{ textDecorationThickness: '2px', textUnderlineOffset: '3px' }}>P</u>ENERIMAAN PAKET</span>
          </Button>

          <Button variant="white" onClick={() => navigate('/LaporanRekapJurnalKasir')} className="d-flex align-items-center gap-2 border shadow-sm px-4 py-2 bg-white" style={{ borderRadius: '8px', transition: 'all 0.2s', borderColor: '#e2e8f0' }}>
            <div className="d-flex align-items-center justify-content-center rounded bg-info-subtle text-info-emphasis" style={{ width: '28px', height: '28px' }}>
              <i className="bi bi-file-earmark-spreadsheet-fill"></i>
            </div>
            <span className="fw-bold" style={{ color: '#334155', fontSize: '0.8rem', letterSpacing: '0.3px' }}>REKAP JURNAL KASIR</span>
          </Button>
        </div>

        {/* SUMMARY CARDS */}

        <Row className="g-3 mb-3">
          {[
            { label: "TOTAL PEMASUKAN", value: totalMasuk, color: "#059669", bg: "linear-gradient(135deg, #d1fae5, #ecfdf5)", icon: "bi-graph-up-arrow", sub: "Tunai + Bank + Dok. + Piutang" },
            { label: "TOTAL PENGELUARAN", value: totalKeluar, color: "#dc2626", bg: "linear-gradient(135deg, #fee2e2, #fef2f2)", icon: "bi-graph-down-arrow", sub: "Seluruh Pengeluaran" },
            { label: "SALDO BERSIH", value: saldo, color: saldo >= 0 ? "#0d9488" : "#f59e0b", bg: saldo >= 0 ? "linear-gradient(135deg, #ccfbf1, #f0fdfa)" : "linear-gradient(135deg, #fef3c7, #fffbeb)", icon: "bi-wallet2", sub: "Masuk - Keluar" },
            { label: "TOTAL TRANSAKSI", value: null, count: filteredList.length, color: "#4f46e5", bg: "linear-gradient(135deg, #e0e7ff, #eef2ff)", icon: "bi-receipt-cutoff", sub: "Total Baris Data" },
          ].map((s, i) => (
            <Col xs={12} sm={6} xl={3} key={i}>
              <div className="border-0 h-100 shadow-sm" style={{ borderRadius: "12px", background: s.bg, borderLeft: `4px solid ${s.color}` }}>
                <div className="p-3 d-flex justify-content-between flex-column h-100">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <div className="fw-bold mb-1" style={{ fontSize: "0.75rem", letterSpacing: "0.8px", color: s.color, opacity: 0.9 }}>{s.label}</div>
                      <div className="fw-bolder" style={{ fontSize: "1.2rem", color: s.color }}>
                        {s.count !== undefined ? s.count : `Rp ${fmt(s.value)}`}
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center shadow-sm" style={{ width: '36px', height: '36px', borderRadius: '10px', background: '#fff', color: s.color }}>
                      <i className={`bi ${s.icon} fs-5`}></i>
                    </div>
                  </div>
                  <div style={{ fontSize: "0.7rem", color: s.color, opacity: 0.75, fontWeight: 500 }}>
                    <i className="bi bi-info-circle me-1"></i>{s.sub}
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        {/* FILTER CARD */}
        <div className="bg-white border rounded shadow-sm mb-3" style={{ borderColor: '#e2e8f0', borderRadius: '12px' }}>
          <div className="p-3">
            <Row className="g-3 align-items-center">
              <Col xs={12} lg={4}>
                <div className="d-flex align-items-center bg-light rounded p-1 border">
                  <div className="d-flex align-items-center px-3 text-muted border-end" style={{ fontSize: '0.75rem', fontWeight: 600, minWidth: '90px' }}>
                    <i className="bi bi-calendar-range me-2"></i> PERIODE
                  </div>
                  <Form.Control type="date" className="border-0 bg-transparent shadow-none px-2" size="sm" value={periodeAwal} onChange={(e) => setPeriodeAwal(e.target.value)} style={{ fontSize: "0.8rem", fontWeight: 500 }} />
                  <span className="text-muted mx-1">-</span>
                  <Form.Control type="date" className="border-0 bg-transparent shadow-none px-2" size="sm" value={periodeAkhir} onChange={(e) => setPeriodeAkhir(e.target.value)} style={{ fontSize: "0.8rem", fontWeight: 500 }} />
                </div>
              </Col>
              <Col xs={12} lg={5}>
                <InputGroup className="shadow-sm rounded">
                  <InputGroup.Text className="bg-white border-end-0 text-muted px-3"><i className="bi bi-search"></i></InputGroup.Text>
                  <Form.Control className="border-start-0 border-end-0 shadow-none py-1" placeholder="Cari keterangan atau No. Nota..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{ fontSize: "0.85rem", fontWeight: 500 }} />
                  {searchQuery && <Button variant="outline-secondary" size="sm" className="border-start-0" onClick={() => setSearchQuery("")}><i className="bi bi-x"></i></Button>}
                </InputGroup>
              </Col>
              <Col xs={12} lg={3}>
                <Button variant="primary" size="sm" className="w-100 fw-bold d-flex align-items-center justify-content-center gap-2 rounded shadow-sm" style={{ background: 'linear-gradient(135deg, #0ea5e9, #0284c7)', border: 'none', height: '33px' }} onClick={fetchKasKasir} disabled={isLoading}>
                  {isLoading ? <Spinner animation="border" size="sm" /> : <><i className="bi bi-arrow-clockwise"></i> MUAT ULANG</>}
                </Button>
              </Col>
            </Row>
          </div>
        </div>

        {/* TABLE SECTION */}
        <div className="bg-white border rounded shadow-sm d-flex flex-column" style={{ borderColor: '#e2e8f0', borderRadius: '12px', minHeight: '400px' }}>
          
          <div className="d-flex align-items-center justify-content-between py-2 px-3 border-bottom">
            <div>
              <h6 className="mb-0 fw-semibold" style={{ color: '#0f172a', fontSize: '0.85rem' }}>
                <i className="bi bi-table text-primary me-2"></i>Rincian Transaksi
              </h6>
            </div>
            <Badge bg="light" text="primary" className="border px-3 py-1 fw-semibold rounded-pill" style={{ fontSize: '0.7rem' }}>
              <i className="bi bi-database me-1"></i> {filteredList.length} Baris Data Ditemukan
            </Badge>
          </div>

          <div className="flex-grow-1" style={{ overflowX: 'auto' }}>
            <Table hover responsive className="mb-0 align-middle" size="sm" style={{ fontSize: '0.82rem', whiteSpace: 'nowrap' }}>
              <thead style={{ background: '#f8fafc' }}>
                <tr>
                  <th className="py-2 px-3 text-muted fw-semibold border-bottom text-center" style={{ fontSize: '0.7rem', width: '5%' }}>#</th>
                  <th className="py-2 text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>NO. NOTA</th>
                  <th className="py-2 text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem', width: '100%', minWidth: '300px' }}>KETERANGAN</th>
                  <th className="py-2 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>TUNAI</th>
                  <th className="py-2 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>BANK</th>
                  <th className="py-2 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>DOKUMEN</th>
                  <th className="py-2 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>PIUTANG</th>
                  <th className="py-2 pe-3 text-end text-muted fw-semibold border-bottom" style={{ fontSize: '0.7rem' }}>KELUAR</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="8" className="text-center py-5">
                      <Spinner animation="border" size="sm" className="text-primary me-2" />
                      <span className="text-muted" style={{ fontSize: '0.8rem' }}>Memuat data...</span>
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item, idx) => (
                    <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td className="py-2 px-3 fw-medium text-muted text-center">{indexOfFirstItem + idx + 1}</td>
                      <td className="py-2 fw-semibold text-primary">{item.no_nota || "—"}</td>
                      <td className="py-2 text-dark text-wrap" style={{ minWidth: '300px' }}>{item.keterangan || "—"}</td>
                      <td className="py-2 text-end fw-semibold" style={{ color: item.tunai > 0 ? "#059669" : "#cbd5e1" }}>{item.tunai > 0 ? fmt(item.tunai) : "—"}</td>
                      <td className="py-2 text-end fw-semibold" style={{ color: item.bank > 0 ? "#059669" : "#cbd5e1" }}>{item.bank > 0 ? fmt(item.bank) : "—"}</td>
                      <td className="py-2 text-end fw-semibold" style={{ color: item.dokumen > 0 ? "#0d9488" : "#cbd5e1" }}>{item.dokumen > 0 ? fmt(item.dokumen) : "—"}</td>
                      <td className="py-2 text-end fw-semibold" style={{ color: item.piutang > 0 ? "#6366f1" : "#cbd5e1" }}>{item.piutang > 0 ? fmt(item.piutang) : "—"}</td>
                      <td className="py-2 pe-3 text-end fw-bold" style={{ color: item.keluar > 0 ? "#dc2626" : "#cbd5e1" }}>{item.keluar > 0 ? fmt(item.keluar) : "—"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-5 text-muted">
                      <div className="mb-2"><i className="bi bi-inbox fs-4 opacity-50"></i></div>
                      <div style={{ fontSize: '0.8rem' }}>Tidak ada data transaksi.</div>
                    </td>
                  </tr>
                )}
              </tbody>
              {filteredList.length > 0 && (
                <tfoot style={{ background: '#f8fafc' }}>
                  <tr>
                    <td colSpan="3" className="py-2 px-3 text-dark fw-bold border-top" style={{ fontSize: '0.75rem' }}>TOTAL</td>
                    <td className="py-2 text-end fw-bold text-success border-top">{fmt(filteredList.reduce((a, c) => a + (c.tunai || 0), 0))}</td>
                    <td className="py-2 text-end fw-bold text-success border-top">{fmt(filteredList.reduce((a, c) => a + (c.bank || 0), 0))}</td>
                    <td className="py-2 text-end fw-bold text-info border-top" style={{ color: '#0d9488' }}>{fmt(filteredList.reduce((a, c) => a + (c.dokumen || 0), 0))}</td>
                    <td className="py-2 text-end fw-bold text-primary border-top">{fmt(filteredList.reduce((a, c) => a + (c.piutang || 0), 0))}</td>
                    <td className="py-2 pe-3 text-end fw-bold text-danger border-top">{fmt(filteredList.reduce((a, c) => a + (c.keluar || 0), 0))}</td>
                  </tr>
                  <tr style={{ background: "linear-gradient(135deg,#f0fdf4,#ecfdf5)" }}>
                    <td colSpan="3" className="py-2 px-3 text-dark fw-bold border-top" style={{ fontSize: '0.8rem' }}>SALDO AKHIR</td>
                    <td colSpan="5" className={`py-2 pe-3 text-end fw-bold border-top ${saldo >= 0 ? "text-success" : "text-danger"}`} style={{ fontSize: '1rem' }}>Rp {fmt(saldo)}</td>
                  </tr>
                </tfoot>
              )}
            </Table>
          </div>

          {/* Pagination Footer */}
          {totalPages > 1 && (
            <div className="py-2 px-3 border-top d-flex justify-content-between align-items-center mt-auto" style={{ background: '#fff' }}>
              <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                Menampilkan <span className="fw-semibold text-dark">{indexOfFirstItem + 1}</span> - <span className="fw-semibold text-dark">{Math.min(indexOfLastItem, filteredList.length)}</span> dari <span className="fw-semibold text-dark">{filteredList.length}</span> hasil
              </span>
              <div className="d-flex gap-1">
                <Button variant="outline-secondary" size="sm" className="d-flex align-items-center px-2 py-0" style={{ fontSize: '0.75rem', borderColor: '#e2e8f0', color: '#475569' }} disabled={currentPage === 1} onClick={() => setCurrentPage(p => Math.max(1, p - 1))}>
                  <i className="bi bi-chevron-left"></i>
                </Button>
                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (page === 1 || page === totalPages || (page >= currentPage - 1 && page <= currentPage + 1)) {
                    return (
                      <Button key={page} variant={page === currentPage ? "primary" : "outline-secondary"} size="sm" className="px-2 py-0 fw-semibold" style={{ fontSize: '0.75rem', width: '26px', borderColor: page === currentPage ? '' : '#e2e8f0', color: page === currentPage ? '#fff' : '#475569' }} onClick={() => setCurrentPage(page)}>
                        {page}
                      </Button>
                    );
                  } else if (page === currentPage - 2 || page === currentPage + 2) {
                    return <span key={page} className="text-muted d-flex align-items-end px-1" style={{ fontSize: '0.75rem' }}>...</span>;
                  }
                  return null;
                })}
                <Button variant="outline-secondary" size="sm" className="d-flex align-items-center px-2 py-0" style={{ fontSize: '0.75rem', borderColor: '#e2e8f0', color: '#475569' }} disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}>
                  <i className="bi bi-chevron-right"></i>
                </Button>
              </div>
            </div>
          )}
        </div>

      </Container>

      {/* MODAL PENERIMAAN PAKET */}
      <Modal show={showModalPaket} onHide={() => setShowModalPaket(false)} size="xl" centered backdrop="static">
        <div className="text-white px-4 py-3 d-flex justify-content-between align-items-center" style={{ background: 'linear-gradient(90deg, #0f172a 0%, #1e293b 100%)', borderTopLeftRadius: '0.4rem', borderTopRightRadius: '0.4rem' }}>
          <h5 className="mb-0 fw-bold" style={{ letterSpacing: '0.5px', fontSize: '1.1rem' }}>
            <i className="bi bi-box-seam me-2 text-warning"></i> PENERIMAAN TITIPAN TUNAI PASIEN PAKET
          </h5>
          <button type="button" className="btn-close btn-close-white" onClick={() => setShowModalPaket(false)}></button>
        </div>
        
        <Modal.Body className="bg-light p-3">
          {/* Top Form */}
          <Row className="mb-3 g-2">
            <Col lg={9}>
              <div className="bg-white p-2 px-3 rounded border shadow-sm h-100 d-flex flex-column justify-content-center">
                <Form.Group as={Row} className="mb-1 align-items-center">
                  <Form.Label column sm={3} className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>JENIS PENERIMAAN</Form.Label>
                  <Col sm={9}>
                    <Form.Select size="sm" className="fw-semibold text-dark shadow-none border-secondary" style={{ backgroundColor: '#fef08a' }} onChange={(e) => {
                      const val = e.target.value;
                      if (val === '104') {
                        setTimeout(() => kirsRef.current && kirsRef.current.focus(), 50);
                      } else if (val) {
                        setTimeout(() => jenisPembayaranRef.current && jenisPembayaranRef.current.focus(), 50);
                      }
                    }}>
                      <option value="">-- Pilih Jenis --</option>
                      <option value="107">107 - Penerimaan Non Operasional</option>
                      <option value="1041">1041 - Titipan Pelunasan Deposit</option>
                      <option value="104">104 - Titipan Pelunasan Piutang</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-1 align-items-center">
                  <Form.Label column sm={3} className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>KIRS | NAMA PASIEN</Form.Label>
                  <Col sm={3}>
                    <Form.Control size="sm" className="shadow-none border-secondary" placeholder="No. KIRS" ref={kirsRef} />
                  </Col>
                  <Col sm={6}>
                    <Form.Control size="sm" className="shadow-none border-secondary" placeholder="Nama Pasien" />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="align-items-center">
                  <Form.Label column sm={3} className="fw-bold text-dark" style={{ fontSize: '0.8rem' }}>URAIAN</Form.Label>
                  <Col sm={9}>
                    <Form.Control size="sm" className="shadow-none border-secondary" placeholder="Uraian penerimaan..." />
                  </Col>
                </Form.Group>
              </div>
            </Col>
            <Col lg={3}>
              <div className="bg-white p-2 px-3 rounded border shadow-sm h-100">
                <Form.Group>
                  <Form.Label className="fw-bold text-center w-100 text-white rounded p-1 mb-2" style={{ fontSize: '0.85rem', background: '#0284c7' }}>TANGGAL</Form.Label>
                  <Form.Control type="date" size="sm" className="bg-dark text-white fw-bold shadow-none text-center" style={{ border: '2px solid #333' }} readOnly value={periodeAkhir} />
                </Form.Group>
              </div>
            </Col>
          </Row>

          {/* Payment Grid */}
          <div className="bg-white rounded border border-2 shadow-sm mb-3" style={{ borderColor: '#0d9488 !important' }}>
            <div className="p-2 border-bottom" style={{ background: '#0d9488' }}>
              <Row className="g-2 text-white text-center">
                <Col md={3}><div className="fw-semibold" style={{ fontSize: '0.75rem' }}>JENIS PEMBAYARAN</div></Col>
                <Col md={2}><div className="fw-semibold" style={{ fontSize: '0.75rem' }}>JENIS KARTU</div></Col>
                <Col md={2}><div className="fw-semibold" style={{ fontSize: '0.75rem' }}>NILAI [Rp]</div></Col>
                <Col md={2}><div className="fw-semibold" style={{ fontSize: '0.75rem' }}>BANK 3 % [Rp]</div></Col>
                <Col md={3}><div className="fw-semibold" style={{ fontSize: '0.75rem' }}>SUB TOTAL [Rp]</div></Col>
              </Row>
            </div>
            <div className="p-2 border-bottom bg-light">
              <Row className="g-2">
                <Col md={3}>
                  <Select 
                    ref={jenisPembayaranRef}
                    options={listRekening.map(r => ({ value: r.kode, label: `${r.kode} - ${r.nm_bank} (${r.jenis_pembayaran})` }))}
                    value={listRekening.map(r => ({ value: r.kode, label: `${r.kode} - ${r.nm_bank} (${r.jenis_pembayaran})` })).find(o => o.value === jenisPembayaranCode) || null}
                    onChange={(selected) => setJenisPembayaranCode(selected ? selected.value : '')}
                    placeholder="- Cari Pembayaran -"
                    styles={{ 
                      control: (base) => ({ ...base, minHeight: '31px', height: '31px', fontSize: '0.8rem', borderColor: '#dee2e6', boxShadow: 'none' }), 
                      valueContainer: (base) => ({ ...base, padding: '0px 8px' }),
                      indicatorsContainer: (base) => ({ ...base, height: '31px' }),
                      menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                    menuPosition="fixed"
                    menuPortalTarget={document.body}
                    isClearable
                  />
                </Col>
                <Col md={2}>
                  <Form.Select size="sm" className="shadow-none border-secondary" style={{ color: '#0f172a' }} value={jenisKartu} onChange={(e) => {
                      const val = e.target.value;
                      setJenisKartu(val);
                      if (val === 'Kredit') {
                        setInputAdmBank(Math.round((parseFloat(inputNilai) || 0) * 0.03));
                      } else {
                        setInputAdmBank(0);
                      }
                    }}>
                      <option value="">- Kartu -</option>
                      <option value="Debit">Debit</option>
                      <option value="Kredit">Kredit</option>
                    </Form.Select>
                </Col>
                <Col md={2}>
                  <Form.Control size="sm" type="number" className="text-end fw-bold text-primary shadow-none" value={inputNilai} onChange={(e) => {
                      const val = parseFloat(e.target.value) || 0;
                      setInputNilai(e.target.value);
                      if (jenisKartu === 'Kredit') {
                        setInputAdmBank(Math.round(val * 0.03));
                      }
                    }} placeholder="0" />
                </Col>
                <Col md={2}>
                  <Form.Control size="sm" type="number" className="text-end bg-light text-success shadow-none" value={inputAdmBank} onChange={(e) => setInputAdmBank(e.target.value)} placeholder="0" />
                </Col>
                <Col md={3}>
                  <div className="d-flex gap-2">
                    <Form.Control size="sm" className="text-end bg-dark text-success fw-bold shadow-none" readOnly value={fmt(inputSubTotal)} />
                    <Button variant="primary" size="sm" className="px-3"><i className="bi bi-plus-lg"></i></Button>
                  </div>
                </Col>
              </Row>
            </div>
            <div style={{ minHeight: '100px', background: '#fff' }} className="p-2">
              <div className="text-center text-muted py-3" style={{ fontSize: '0.85rem' }}>Belum ada rincian pembayaran ditambahkan.</div>
            </div>
          </div>

          {/* Totals & Footer Info */}
          <Row className="g-2">
            <Col lg={7} className="d-flex flex-column justify-content-between">
              <div className="d-flex gap-3 mb-2 p-2 bg-white border rounded shadow-sm opacity-75">
                <i className="bi bi-cash-stack fs-2 text-success"></i>
                <i className="bi bi-credit-card-2-front fs-2 text-primary"></i>
                <i className="bi bi-credit-card fs-2 text-warning"></i>
                <i className="bi bi-wallet2 fs-2 text-info"></i>
              </div>
              <InputGroup size="sm" className="shadow-sm">
                <InputGroup.Text className="text-white fw-semibold border-0 px-3" style={{ background: '#004080', fontSize: '0.85rem' }}>
                  NAMA TERCETAK DI KUITANSI :
                </InputGroup.Text>
                <Form.Control className="border-secondary fs-6 fw-semibold" />
              </InputGroup>
            </Col>
            <Col lg={5}>
              <div className="p-2 px-3 rounded shadow-sm d-flex flex-column gap-1" style={{ background: '#cbd5e1' }}>
                {[
                  { label: 'SUB TOTAL [Rp]', value: '0' },
                  { label: 'ADM BANK 3 % [Rp]', value: '0' },
                  { label: 'TOTAL [Rp]', value: '0' },
                  { label: 'SISA [Rp]', value: '0' },
                  { label: 'UANG KEMBALI [Rp]', value: '0', highlight: true }
                ].map((item, idx) => (
                  <div key={idx} className="d-flex align-items-center">
                    <div className="fw-bold" style={{ width: '140px', fontSize: '0.75rem', color: '#004080' }}>{item.label}</div>
                    <div className={`flex-grow-1 text-end fw-bold px-3 py-1 border border-secondary ${item.highlight ? 'bg-dark text-success fs-5' : 'bg-dark text-success fs-6'}`} style={{ fontFamily: 'monospace' }}>
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        
        <Modal.Footer className="bg-light border-top justify-content-between px-3 py-2">
          <Button variant="danger" className="fw-bold px-4 shadow-sm" onClick={() => setShowModalPaket(false)}>
            <i className="bi bi-x-circle me-2"></i> KELUAR
          </Button>
          <Button variant="success" className="fw-bold px-4 shadow-sm">
            <i className="bi bi-save me-2"></i> SIMPAN KUITANSI
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default KasKasir;
